import React from "react";
import CrudPage from "../../components/admin/CrudPage";

const WAREHOUSES = [
  { value: "CDMX", label: "CDMX" },
  { value: "GDL", label: "Guadalajara" },
  { value: "MTY", label: "Monterrey" },
  { value: "ELP", label: "El Paso, TX" },
];

const config = {
  title: "Inventario",
  eyebrow: "Operaciones",
  resource: "inventory",
  columns: [
    { key: "sku", label: "SKU" },
    { key: "name", label: "Producto" },
    { key: "category", label: "Categoría" },
    { key: "warehouse", label: "Almacén" },
    {
      key: "stock",
      label: "Stock",
      type: "number",
      render: (it) => (
        <span
          className={
            it.stock <= it.min_stock ? "text-red-700 font-semibold" : "text-slate-700"
          }
        >
          {it.stock}
        </span>
      ),
    },
    { key: "min_stock", label: "Mín.", type: "number" },
    { key: "unit_price", label: "Precio", type: "currency" },
  ],
  fields: [
    { key: "sku", label: "SKU", required: true },
    { key: "name", label: "Producto", required: true },
    { key: "category", label: "Categoría", required: true },
    { key: "warehouse", label: "Almacén", type: "select", options: WAREHOUSES, required: true },
    { key: "stock", label: "Stock actual", type: "number", required: true },
    { key: "min_stock", label: "Stock mínimo", type: "number" },
    { key: "unit_cost", label: "Costo unitario", type: "number" },
    { key: "unit_price", label: "Precio unitario", type: "number" },
  ],
};

export default function AdminInventory() {
  return <CrudPage config={config} />;
}
